module.exports = __webpack_public_path__ + "static/media/kayak.38ac57a3.png";